export default __webpack_public_path__ + "static/media/we-don't-talk-anymore.77be92e9.jpg";